import styled from 'styled-components'
import { NotificationLevel } from '~/components/NotificationBar'
import { FlexContainer } from '~/components/Layout'

const levelColors = {
  info: 'textBlack',
  warning: 'alertWarningText',
  risk: 'alertRiskText',
}

export const StyledOrderPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #ffffff;
  border-radius: 16px;
  border: 0.5px solid #e7e2ff;
  width: 435px;
  position: relative;

  ${({ theme }) => theme.media.sm`
    margin-bottom: 15px;
    width: 100%;
  `}
`

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  left: 0px;
  outline: none;
  position: absolute;
  top: 10px;
  transform: rotate(90deg);
`

export const Title = styled.div`
  box-shadow: inset 0px -1px 0px #eaecf6;
  color: #191c1e;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 14px 0;
  text-align: center;
  width: 100%;
`

export const CountdownTitle = styled.span`
  background: #f5f7fb;
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  color: #8d93b5;
`

export const CountdownNumber = styled.span`
  font-weight: 600;
  color: #6bc7a1;
`

export const QuoteExpiredTitle = styled.span`
  background: #ffeae9;
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  color: #d66665;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 8px 20px 25px;
  width: 100%;
`

export const StyledDividerLite = styled.div`
  position: relative;
  height: 1px;
  border-top: 1px dashed #e6e8eb;
  margin: 8px 0;
`

export const StyledDivider = styled(StyledDividerLite)`
  margin: 16px 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -8px;
    width: 8px;
    height: 16px;
    border: 0.5px solid #e7e2ff;
    background: ${({ theme }) => theme.colors.bgColor};
  }

  &::before {
    left: -20.5px;
    border-radius: 0 16px 16px 0;
    border-left: none;
  }

  &::after {
    right: -20.5px;
    border-radius: 16px 0 0 16px;
    border-right: none;
  }
`

export const TokenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin: 0;
  width: 100%;
`

export const StyledTokenLabel = styled(FlexContainer)`
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textBlack2};
`

export const StyledTokenNetworkLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  color: ${({ theme }) => theme.colors.textGrey2};
`

export const TokenValue = styled.div`
  color: #9598ab;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const TokenAmount = styled.div`
  color: #191c1e;
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 20px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textGrey2};
`

export const StyledTipValue = styled.span`
  display: flex;
  color: #2c2842;
  letter-spacing: 0.2px;
`

export const StyledRewards = styled(Row)`
  margin-top: 8px;
  border-top: 0.5px dashed #8d93b5;
  padding-top: 8.6px;
  color: #604dbc;
`

export const StyledRewardsValueArea = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const StyledGreenShield = styled.img`
  width: 14px;
  height: 16px;
  cursor: pointer;
`

export const StyledDetailValue = styled.span<{ level?: NotificationLevel }>`
  color: ${({ level = 'info', theme }) => theme.colors[levelColors[level]]};
  font-weight: ${({ level = 'info' }) => (level === 'info' ? 400 : 500)};
  letter-spacing: 0.2px;
  max-width: 195px;
  text-align: right;
  overflow-wrap: break-word;
`

export const StyledIconSwap = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 6px;
`
